import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const CANCEL_ADVISOR_SESSION = gql`
  mutation CancelAdvisorSession($input: CancelAdvisorSessionInput!) {
    cancelAdvisorSession(input: $input) {
      advisorSession {
        ...AdvisorSessionFragment
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
